import {sortFormats} from './sortFormats';

// Ссылка на YouTube-плейлист: /playlist?list=… или любая ссылка youtube.com с list=
// (watch?v=…&list=…). Ответ /api/convert на неё — массив элементов-заглушек.
export function isYoutubePlaylistUrl(value) {
  try {
    const u = new URL(value);
    if (!/(^|\.)youtube\.com$/i.test(u.hostname)) return false;
    return u.pathname.replace(/\/+$/, '') === '/playlist' || u.searchParams.has('list');
  } catch (e) {
    return false;
  }
}

// Ответ /api/convert — выдача плейлиста (PlaylistResult.vue): непустой массив на ссылку плейлиста.
// Одно условие для LinkAnalyzerView.vue (что рисовать) и app.js (слать ли tzLandingFree:result).
export function isPlaylistResponse(url, data) {
  return Array.isArray(data) && data.length > 0 && isYoutubePlaylistUrl(url);
}

// Форматы с настоящей ссылкой: элементы плейлиста приходят с url: [{}] —
// без этого фильтра карточка показала бы «Unduh» без ссылки.
export function realFormats(urls) {
  return sortFormats(urls).filter((f) => f && typeof f.url === 'string' && f.url.length > 0);
}
